// extracted by mini-css-extract-plugin
export var bottomAlign = "index-module--bottomAlign--G7OmD";
export var container = "index-module--container--e8kpZ";
export var defItem = "index-module--defItem--PK5GS";
export var defList = "index-module--defList--zr30B";
export var definition = "index-module--definition--T6xqA";
export var imageBox = "index-module--imageBox--+k+OZ";
export var noun = "index-module--noun--xl0xc";
export var phonetic = "index-module--phonetic--M5R+g";
export var textBox = "index-module--textBox--p4gzk";
export var title = "index-module--title--4j9gg";